import { DocumentNode, gql } from '@apollo/client'

export const CREATE_SECTION: DocumentNode = gql`
    mutation CreateSection($daycare_id: Int!, $name: String!, $max: Int) {
        createSection(daycare_id: $daycare_id, name: $name, max: $max)
    }
`

export const GET_SECTIONS: DocumentNode = gql`
    query GetSections($daycare_id: Int!) {
        getSections(daycare_id: $daycare_id) {
            id
            daycareId
            max
            name
            sectionGroupId
        }
    }
`

export const UPDATE_SECTION: DocumentNode = gql`
    mutation UpdateSection($section_id: Int!, $name: String, $max: Int, $daycare_id: Int!) {
        updateSection(section_id: $section_id, name: $name, max: $max, daycare_id: $daycare_id)
    }
`

export const DELETE_SECTION: DocumentNode = gql`
    mutation DeleteSection($section_id: Int!, $daycare_id: Int!) {
        deleteSection(section_id: $section_id, daycare_id: $daycare_id)
    }
`

export const GET_CHILD_WITHOUT_SECTION: DocumentNode = gql`
    query GetChildWithoutSection($daycare_id: Int!) {
        getChildWithoutSection(daycare_id: $daycare_id)
    }
`
